import React from 'react'
import styles from './styles.css'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'

@withGraphQL(gql`query getSignature ($signatureId: ID) {
  signature (signatureId: $signatureId) {
    _id
    image {
      url
    }
  }
}`)
export default class Image extends React.Component {

  static propTypes = {
    signature: PropTypes.object
  }

  render () {
    if (!this.props.signature) return <span>Not found</span>
    const signature = this.props.signature.image.url
    return <div className={styles.signature} style={{backgroundImage: `url(${signature})`}} />
  }

}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/PrepareTemplate/Field/Signature/Image/index.js